import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ColorPicker } from "designSystem/index";
import { cssCheckeredBackground, TransparentSwatch } from "designSystem/components/colorPicker/ColorPicker";
import { Box, ButtonMenu } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useRef } from "react";
import { useLightboxStore } from "./LightboxStore";

interface ColorBoxProps {
	backgroundColor: string;
}

const ColorBox: FunctionComponent<ColorBoxProps> = (props) => {
	const { backgroundColor } = props;
	const loc = useLocale();

	return (
		<Box
			aria-label={loc.resource("BackgroundColor")}
			style={{
				background: (backgroundColor === "transparent") ? "#FFF" : `linear-gradient(${backgroundColor}, ${backgroundColor}), ${cssCheckeredBackground}`,
				border: "1px solid rgba(128, 128, 128, 0.5)",
				borderRadius: "3px",
				height: "16px",
				width: "16px",
			}}
		>
			{backgroundColor === "transparent" && (
				<TransparentSwatch
					sx={{
						left: "3px",
						top: "11px",
					}}
				/>
			)}
		</Box>
	);
};

const ColorPickerBox: FunctionComponent<{}> = observer(() => {
	const ref = useRef(null);
	const loc = useLocale();
	const backgroundColorRes = loc.resource("BackgroundColor");

	const {
		backgroundColor,
		closeColorPicker,
		forceColorPickerUpdate,
		onBackgroundColorChangeComplete,
		recentCustomColors,
		setForceColorPickerUpdate,
		setOpenColorPicker,
	} = useLightboxStore();

	return (
		<ButtonMenu
			aria-label={backgroundColorRes}
			design="darkMode"
			endIcon={(
				<ArrowDropDownIcon
					sx={{
						height: 16,
						width: 16,
					}}
				/>
			)}
			label={<ColorBox backgroundColor={backgroundColor} />}
			onClose={closeColorPicker}
			onOpen={() => setOpenColorPicker(true)}
			ref={ref}
			sx={{
				display: "flex",
				padding: 1,
				position: "relative",
				zIndex: 1,
			}}
			title={backgroundColorRes}
		>
			<ColorPicker
				color={backgroundColor}
				onColorChange={onBackgroundColorChangeComplete}
				onPageChange={setForceColorPickerUpdate}
				recentCustomColors={recentCustomColors}
			/>
		</ButtonMenu>
	);
});

export default ColorPickerBox;
